var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { useEffect, useState } from "react";
import { useWatch } from "react-hook-form";
import { Box, Button, FormLabel, Grid, TextField, Tooltip, Typography, } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { ProbeSelectionTable } from "../utils/ProbeSelectionTable";
import { getDatasets, readDCfile } from "../apps/results/fetchDcData";
export function CsProbeSelector({ hookFormRegisterFunc, setValue, formKey, label, error, disabled = false, }) {
    const [openDialog, setOpenDialog] = useState(false);
    const formValue = useWatch({
        name: formKey,
    });
    const hasSelection = !!formValue;
    //   const [isLoading, setIsLoading] = useState(false);
    const clearSelection = () => {
        setValue(formKey, "");
    };
    const handleClick = () => {
        setOpenDialog(true);
    };
    const handleSelect = (e) => {
        setValue(formKey, e.name);
        setOpenDialog(false);
    };
    const _a = hookFormRegisterFunc(formKey, {
        disabled: disabled,
    }), { ref } = _a, inputProps = __rest(_a, ["ref"]);
    const fetchProbes = () => __awaiter(this, void 0, void 0, function* () {
        // readDCfile(ds_id, token);
        const datasets = yield getDatasets({
            remotepath: "SystemBuilder/probes",
        });
        if (!datasets || datasets.length == 0) {
            console.error("Could not fetch SystemBuilder/probes dataset.");
            return;
        }
        const ds_id = datasets[0]["id"];
        const probesStr = yield readDCfile(ds_id, ["probe_svg.json"]);
        if (!probesStr || typeof probesStr !== "string")
            return;
        const _probes = JSON.parse(probesStr);
        const arrayfiedProbes = Object.entries(_probes);
        const _rows = arrayfiedProbes
            .map((p) => createData(p[0], p[1].replace("120px", "80px")))
            .sort((p1, p2) => p1.name
            .replace(/[[(-]/g, "")
            .localeCompare(p2.name.replace(/[[(-]/g, "")));
        setProbes(_rows);
    });
    const [probes, setProbes] = useState();
    useEffect(() => {
        if (probes)
            return;
        fetchProbes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsx(Box, { children: _jsxs(Grid, Object.assign({ container: true, direction: "column" }, { children: [_jsx(Grid, Object.assign({ item: true }, { children: _jsx(FormLabel, { children: label }) })), _jsxs(Grid, Object.assign({ container: true, item: true, alignItems: "center", spacing: 1, direction: "row", sx: { overflow: "hidden", textOverflow: "ellipsis" } }, { children: [_jsx(Grid, Object.assign({ item: true, xs: "auto", sx: { display: "none" } }, { children: _jsx(TextField, Object.assign({ inputRef: ref }, inputProps, { disabled: disabled, label: label, error: !!error, helperText: error, inputProps: { readOnly: true }, size: "small", sx: { width: "100%" } })) })), _jsx(Grid, Object.assign({ item: true, xs: true }, { children: hasSelection ? (_jsx(Button, Object.assign({ onClick: clearSelection, variant: "outlined", color: "error", sx: { width: "120px" }, endIcon: _jsx(ClearIcon, {}) }, { children: "Clear" }))) : (_jsx(Button
                            // disabled={isLoading}
                            , Object.assign({ 
                                // disabled={isLoading}
                                onClick: handleClick, variant: "outlined", sx: { width: "120px" } }, { children: "Select" }))) })), _jsx(Grid, Object.assign({ item: true, xs: true, zeroMinWidth: true }, { children: _jsx(Tooltip, Object.assign({ title: formValue, arrow: true, placement: "top" }, { children: _jsx(Typography, Object.assign({ variant: "caption" }, { children: formValue })) })) })), _jsx(ProbeSelectionTable, { open: openDialog, setOpen: setOpenDialog, onSelectRow: handleSelect, probeRows: probes ? probes : [], notReady: probes === undefined })] })), error ? (_jsx(Grid, Object.assign({ item: true, xs: true }, { children: _jsx(Typography, Object.assign({ variant: "caption", sx: { color: "#d32f2f", pl: 5 } }, { children: error })) }))) : null] })) }));
}
function createData(name, image) {
    return { name, image };
}
